import { render, staticRenderFns } from "./BuscarBLPage.vue?vue&type=template&id=66f963e8"
import script from "./BuscarBLPage.vue?vue&type=script&lang=js"
export * from "./BuscarBLPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports